import apiClient from './apiClient';

// ============================================================
// N301 - 客訴原因明細表 API types and client
// ============================================================

export interface N301ReportRow {
  fn110_01: string;        // 客訴單號
  fn110_11: string | null; // 客訴日期
  fn110_12: string;        // 客戶/廠商代號
  fn110_15: number;        // 匯率
  fn110_202: number;       // 客戶要求金額
  fn110_242: number;       // 廠商1金額
  fn110_252: number;       // 廠商2金額
  fn110_262: number;       // 廠商3金額
  fn110_272: number;       // 其他金額
  fn110_22: string;        // 部門代號
  fn110_84: string;        // 結案狀態 (P=已結案)
  fn110_16: number;        // 金額1
  fn110_17: number;        // 金額2
  fn112_02: number;        // 原因序號
  fn112_11: string;        // 原因代號
  fn112_13: number;        // 原因費率
  fn112_14: number;        // 原因金額
  fn112_amt: number;       // 計算金額 = ROUND(FN112_13 * FN112_14, 0)
  customer_name: string;   // 客戶名稱
  dept_name: string;       // 部門名稱
  cause_name: string;      // 原因名稱
  status_text: string;     // 結案狀態文字
}

export interface N301SummaryRow {
  group_key: string;    // 分組鍵值
  group_name: string;   // 分組名稱
  total_amt: number;    // 小計金額
  record_count: number; // 筆數
}

export interface N301ReportResponse {
  items: N301ReportRow[];
  customerSummary: N301SummaryRow[];
  causeSummary: N301SummaryRow[];
  total: number;
  filterDesc: string;
}

export interface N301ReportParams {
  startDate?: string;
  lastDate?: string;
  startCause?: string;
  lastCause?: string;
  startCustomer?: string;
  lastCustomer?: string;
  startDept?: string;
  lastDept?: string;
  caseStatus?: number;
  reportTypes?: number[];
}

export const n301Api = {
  async query(params: N301ReportParams): Promise<N301ReportResponse> {
    const body: Record<string, unknown> = {};
    if (params.startDate)     body.startDate     = params.startDate;
    if (params.lastDate)      body.lastDate      = params.lastDate;
    if (params.startCause)    body.startCause    = params.startCause;
    if (params.lastCause)     body.lastCause     = params.lastCause;
    if (params.startCustomer) body.startCustomer = params.startCustomer;
    if (params.lastCustomer)  body.lastCustomer  = params.lastCustomer;
    if (params.startDept)     body.startDept     = params.startDept;
    if (params.lastDept)      body.lastDept      = params.lastDept;
    if (params.caseStatus !== undefined) body.caseStatus = params.caseStatus;
    if (params.reportTypes && params.reportTypes.length > 0) body.reportTypes = params.reportTypes;

    return (await apiClient.post('/api/n301/query', body)).data;
  },
};
